<template>
  <h2>{{ $t('home.bikeable_worldwide_title') }}</h2>
  <p>
    {{ $t('home.bikeable_worldwide_explanation') }}
  </p>
  <h3>{{ $t('country.country_choose_title') }}</h3>
  <ul class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 place-items-center gap-2 mb-2 ">
    <li v-for="country in platformSettings.getAvailableCountries()">
      <ButtonPrimary
        class="min-w-[300px] flex items-center justify-center text-center gap-1"
        @click="selectCountry(country)"><span class="text-4xl">{{ countryHelpers.flagEmoji(country) }}</span><span>{{ $t('country.country_' + country) }}</span>
      </ButtonPrimary>
    </li>
  </ul>
  <h3>{{ $t('home.bikeable_worldwide_cta_title') }}</h3>
  <p>{{ $t('home.bikeable_worldwide_cta_text') }} <a class="text-theme-primary" href="mailto:info@moveable.ch">info@moveable.ch</a></p>

</template>
<script setup lang="ts">
const platformSettings = usePlatformSettings();

const selectCountry = (countryCode: string) => {
  platformSettings.setCountryCode(countryCode);
};


</script>


